import {
  AllessehContentQueryBody,
  AllessehQuerySortKeyTypes,
  AllessehQuerySortOrderType
} from 'hooks/useAllessehContentQuery';

export const DEFAULT_QUERY = {
  query: {},
  sort: [{ key: AllessehQuerySortKeyTypes.LiveDate, order: AllessehQuerySortOrderType.DESC }]
} as AllessehContentQueryBody;
